// src/components/Sidebar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const SidebarContainer = styled.div`
  width: ${props => props.isOpen ? '250px' : '60px'};
  height: 100vh;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  transition: width 0.3s ease;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  
  @media (max-width: 768px) {
    width: ${props => props.isOpen ? '100vw' : '60px'};
  }
`;

const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  margin-right: ${props => props.isOpen ? '15px' : '0'};
`;

const MenuList = styled.ul`
  list-style: none;
  padding: 20px 0;
`;

const MenuItem = styled.li`
  padding: 12px 20px;
  margin: 5px 0;
  
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #1d1d1f;
  display: flex;
  align-items: center;
  font-weight: 400;
`;

const IconWrapper = styled.span`
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);

  const handleLinkClick = () => {
    // Close sidebar on mobile when a link is clicked
    if (window.innerWidth <= 768) {
      setIsOpen(false);
    }
  };

  // Menu items with their corresponding icons/emojis
  const menuItems = [
    { path: '/', label: 'Home', icon: '🏠' },
    { path: '/course', label: 'Courses', icon: '🔍' },
    { path: '/company-directory', label: 'Company Directory', icon: '🏢' },
    { path: '/skills-mapper', label: 'Skills Mapper', icon: '🗺️' },
    { path: '/interview-questions', label: 'Interview Question Bank', icon: '💼' },
    { path: '/role-explorer', label: 'Role Explorer', icon: '🔍' }
  ];

  return (
    <SidebarContainer isOpen={isOpen}>
      <SidebarHeader>
        <ToggleButton 
          isOpen={isOpen} 
          onClick={() => setIsOpen(!isOpen)}
        >
          ☰
        </ToggleButton>
        {isOpen && <h3>Power Careers</h3>}
      </SidebarHeader>
      
      <MenuList>
        {menuItems.map((item, index) => (
          <MenuItem key={index}>
            <StyledLink to={item.path} onClick={handleLinkClick}>
              {isOpen ? (
                item.label
              ) : (
                <IconWrapper title={item.label}>
                  {item.icon}
                </IconWrapper>
              )}
            </StyledLink>
          </MenuItem>
        ))}
      </MenuList>
    </SidebarContainer>
  );
};

export default Sidebar;